module.exports = __webpack_public_path__ + "static/media/hometown-3-shot-4-mobile.118fee15.webp";